<template>
  <!-- your other controls… -->
  <v-card-title class="d-flex align-center data-table-controls">
    <v-text-field
      v-model="search"
      label="Search by User or Agent"
      clearable
      dense
      hide-details
      class="pr-4"
      @click:clear="collapseTableRows"
      @input="searchUpdated"
    />
    <v-tooltip bottom v-if="disableExpandAllCollapseAll">
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="d-inline-flex">
          <v-btn small disabled color="blue darken-2" class="mr-2">
            Expand All
          </v-btn>
          <v-btn small disabled color="blue darken-2" class="ml-2 mr-4">
            Collapse All
          </v-btn>
        </div>
      </template>

      <span>
        Expand/Collapse options are unavailable because there are more than
        1,000 users and agents.<br />Please use the search to narrow the list
        and enable these options.
      </span>
    </v-tooltip>
    <template v-else>
      <v-btn
        small
        @click="expandTableRows"
        :loading="expanding"
        color="blue darken-2"
        dark
        class="mr-2"
      >
        Expand All
      </v-btn>
      <v-btn
        small
        @click="collapseTableRows"
        :loading="collapsing"
        color="blue darken-2"
        dark
        class="ml-2 mr-4"
      >
        Collapse All
      </v-btn>
      <export-menu></export-menu>
    </template>
  </v-card-title>
</template>

<script>
import ExportMenu from "../../components/Widgets/ExportMenu.vue";
const ROW_COUNT_THRESHOLD = 1000;

export default {
  components: {
    ExportMenu
  },
  props: {
    expanding: {
      type: Boolean,
      required: true
    },
    collapsing: {
      type: Boolean,
      required: true
    },
    aggRowSize: {
      type: Number,
      default: 0
    },
    nonAggRowSize: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      search: "",
      expandAll: false,
      collapseAll: false
    };
  },
  methods: {
    expandTableRows() {
      this.expandAll = !this.expandAll;
      this.$emit("expand-aggregate-table", this.expandAll);
    },
    collapseTableRows() {
      this.collapseAll = !this.collapseAll;
      this.$emit("collapse-aggregate-table", this.collapseAll);
    },
    searchUpdated() {
      this.$emit("table-search-updated", !this.search ? "" : this.search);
    }
  },
  computed: {
    totalPotentialRowCount() {
      return this.aggRowSize + this.nonAggRowSize;
    },
    disableExpandAllCollapseAll() {
      // need to turn off buttons when lists are too big
      return this.totalPotentialRowCount > ROW_COUNT_THRESHOLD;
    }
  },
  mounted() {},
  watch: {}
};
</script>

<style scoped>
.data-table-controls {
  border-radius: 8px !important;
  background-color: rgba(1, 106, 175, 0.05);
}
</style>
